module.exports = __webpack_public_path__ + "static/FSD-1-3e7824b3b5cf19de1e00daedb3b64c3b.jpg";